export default __webpack_public_path__ + "static/media/apple-brands.a993aaa4.svg";